<template>
    <div>
        <CuentaAtras @tiempoTerminado="tiempoTerminado"/>
        <PageTitle 
            :title="$t('nuevo_abono.titulo', { temporada: lista.nombre, abono: teatro.texto_abono })" 
            class="strech"
        />
        <section class="padding-vertical-content">
            <Stepper 
                ref="stepper"
                :steps="steps" 
            >
                <template #pasoAbonos="{ changeStep }">
                    <SeleccionarAbonos
                        @abonosSeleccionados="(data) => onAbonosSeleccionados(data, changeStep)"
                    />                
                </template>
                <template #pasoDatos="{ changeStep }">
                    <DatosAbonos
                        :precios="precios_disponibles"
                        :session_id="session_id"
                        :sesiones="sesiones"
                        @datos-guardados="(data) => {
                            datos_resumen = data;
                            changeStep()
                        }"
                        @volver="() => {
                            sesiones = [];
                            session_id = null;
                            precios_disponibles = [];
                            changeStep(true)
                        }"
                    />
                </template>
                <template #pasoResumen="{ changeStep }">
                    <div class="container">
                        <b-row>
                            <b-col cols="12">
                                <ResumenCompraComponent
                                    :formulario="datos_resumen.formulario"
                                    :datos_guardados="datos_resumen.datos_compradores"
                                    :envio_domicilio="false"
                                    :iva="footer.iva_abono"
                                    :activar_referidos="false"
                                    :session_id="session_id"
                                    :activar_saldo_monedero="false"
                                    :loading="false"
                                    :desactivar="false"
                                    @compraConfirmada="() => onCompraConfirmada(changeStep)"
                                />
                            </b-col>
                        </b-row>
                    </div>                    
                </template>
                <template #pasoPago>
                    <div class="container">
                        <div class="row">
                            <div class="col-12">
                                <h2 class="m-0 h1 text-uppercase">
                                    {{ $t('compra.confirmacion_compra') }}
                                </h2>
                                <div class="subtitle h3 light mb-3 mb-lg-5">
                                    {{ $t('compra.introduce_datos') }}
                                </div>
                                <PagoPaycometComponent
                                    ref="pago"
                                    tipo_venta="abonos-sin-recinto"
                                    :jet_id="datos_resumen.jet_id"
                                    :session_id="session_id"
                                />		
                            </div>
                        </div>
                    </div>
                </template>
            </Stepper>

            <ModalCuentaAtrasCarrito @close="close('carrito-terminado')"/>
            <ModalCuentraAtrasAvisoCarrito :secondsLeft="300" @close="close('carrito-aviso')"/>
        </section>
    </div>
</template>

<script>
    import Stepper from '@/components/frontend/events/compra/components/Stepper.vue';

    import CuentaAtras from '@/components/frontend/events/compra/CuentaAtras';
    import PageTitle from '@/components/frontend/shared/PageTitle';
    import { useHead } from '@/composables/common/seo/useHead';
    import SeleccionarAbonos from './SinRecinto/SeleccionarAbonos.vue';
    import DatosAbonos from './SinRecinto/DatosAbonos.vue';
    import ResumenCompraComponent from './ResumenCompraComponent.vue';
    import PagoPaycometComponent from '@/components/frontend/compra/components/PagoPaycometComponent.vue';
    import ModalCuentaAtrasCarrito from '@/components/common/carrito/ModalCuentaAtrasCarrito.vue';
    import ModalCuentraAtrasAvisoCarrito from '@/components/common/carrito/ModalCuentraAtrasAvisoCarrito.vue';
    import { useAbonoTracking } from '@/composables/front/analytics/useAbonoTracking';

    export default {
        data() {
            return {
                sesiones: [],
                session_id: null,
                precios_disponibles: [],
                datos_resumen: null,
                abonos_seleccionados: []
            }
        },
        computed: {
            lista() {
                return this.$store.getters.getListaAbonados;
            },
            teatro(){
                return this.$store.getters.getTeatro
            },
            footer() {
                return this.$store.getters.getFooter;
            },
            steps() {
                return [
                    { label: this.$t('abonados.seleccionar_abonos'), slot: 'pasoAbonos' },
                    { label: this.$t('abonados.rellenar_datos'), slot: 'pasoDatos' },
                    { label: this.$t('abonados.resumen'), slot: 'pasoResumen' },
                    { label: this.$t('abonados.pago'), slot: 'pasoPago' }
                ]
            }
        },
        methods: {
            tiempoTerminado() {
                console.log('Tiempo terminado');
            },
            close() {
                window.location.reload();
            },
            onAbonosSeleccionados(data, changeStep) {
                this.sesiones = data.sesiones;
                this.session_id = data.session_id;
                this.precios_disponibles = data.precios_disponibles;
                this.abonos_seleccionados = data.sesiones;

                const { trackBeginCheckout } = useAbonoTracking({ store: this.$store, getVuexAlias: this.config.getVuexAlias });
                trackBeginCheckout({
                    abono_id: this.lista.id,
                    abono_name: this.lista.nombre,
                    lista_abonados: [this.lista],
                    resumen_total: this.precios_disponibles?.reduce((sum, p) => sum + (p.precio || 0), 0) || 0,
                    moneda: 'EUR',
                });

                changeStep();
            },
            onCompraConfirmada(changeStep) {

                changeStep();
            }
        },
        created() {
            useHead('Venta de abonos');
        },
        components: {
            CuentaAtras, PageTitle, Stepper, SeleccionarAbonos, DatosAbonos, ResumenCompraComponent, PagoPaycometComponent,
            ModalCuentaAtrasCarrito, ModalCuentraAtrasAvisoCarrito
        }
    }
</script>
